export default __webpack_public_path__ + "static/media/icon-feather-chevron-down.dd62fe8a.svg";